import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/utils/commImport'
import '@/assets/style/common.less';
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
